<template>
  <span
    class="repo-label-item"
    :style="{
      'background-color': '#' + label?.hexColor
    }"
  >
    <span
      class="gf-adaptate-color repo-list-label"
      v-truncate-text="{
        mediaValue: {
          sm: 30,
          md: 30,
          lg: 30,
          xl: 30,
          coefficient: 100,
          base: label?.title?.length
        },
        originalText: label?.title
      }"
    >
      {{ label?.title }}
    </span>
    <i
      v-if="deletable"
      class="gf-icon gf-icon-x gf-adaptate-color repo-list-icon"
      @click="$emit('delete', label)"
    />
  </span>
</template>

<script>
import { truncateTextDirective } from '@/directives';

export default {
  name: 'RepoLabelItem',
  directives: { truncateText: truncateTextDirective },
  props: {
    label: {},
    deletable: {
      default: false
    }
  }
};
</script>

<style lang="scss">
$this: '.repo-label-item';

#{$this} {
  width: fit-content;
  height: fit-content;
  min-height: 22px;
  padding: 2px 8px;
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 1.2;
  border-radius: 14px;

  & > i {
    cursor: pointer;
  }
}
</style>
